import { GET_SIZES } from "../../type/sizes";
// **  Initial State
const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 1,
  percentage: 0,
  params: {},
};

const sizeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SIZES:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default sizeReducer;
